import { createFileRoute } from "@tanstack/react-router";
import { InvoicesScreen } from "../components/invoices/InvoicesScreen";

export const Route = createFileRoute("/_auth/invoices")({
  staticData: { titleKey: "nav.invoices", breadcrumbKey: "breadcrumb.operate", breadcrumbN: 8 },
  component: InvoicesScreen,
});
